import type { IEditorPlatformComponentModel } from '@wix/editor-elements-types/editorPlatform';

import { createRegistry } from '../createRegistry';

import { IComponentLoader, IComponentsRegistry } from '../types';

export type IEditorPlatformComponentLoader =
  IComponentLoader<IEditorPlatformComponentModel>;

export type IEditorPlatformComponentsRegistry =
  IComponentsRegistry<IEditorPlatformComponentModel>;

export const registry = createRegistry<IEditorPlatformComponentModel>({
  host: 'editorPlatform',
});
export default registry;
export { IEditorPlatformComponentModel };

export * from '../types';
